import React from 'react';
import styled from 'styled-components';
import { style, User, useSocialInfo } from '../../api';

import { desktop, noDesktop } from '../../style/constants';
import { TextRegular12 } from '../common/Text';
import SocialIcon from '../common/SocialIcon';

const UserSocial = ({ user }: { user: User }) => {
  const { data: socialInfo = [] } = useSocialInfo(user?.id);

  return (
    <Wrapper>
      {socialInfo.map((item) => (
        <Row
          href={item.url}
          key={item.id}
          target="_blank"
          rel="noopener noreferrer"
        >
          <SocialIcon item={item} greyoutOnMobile={false} />
          <TextRegular12>{item.username}</TextRegular12>
        </Row>
      ))}
    </Wrapper>
  );
};

export default UserSocial;

const Wrapper = styled.div`
  display: flex;
  width: 100%;

  @media ${desktop} {
    flex-direction: column;
  }
  align-items: flex-start;
  flex-wrap: wrap;
`;

const Row = styled.a`
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media ${noDesktop} {
    flex-basis: 50%;
  }

  > ${TextRegular12} {
    color: ${style.grey_dark_new};
    margin-left: 8px;
  }
`;
